import { Card, Col, Row, Table } from "antd";
import React from "react";
import logoImg from "../../images/logo.jpg";
import { ColumnProps } from "antd/es/table";
import "./style.css";

const Home = () => {
  const dataSourcePay = [
    {
      key: "1",
      a1: "0001",
      a2: "2020-01-03",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "340,000",
    },
    {
      key: "2",
      a1: "0002",
      a2: "2020-01-09",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "940,000",
    },
    {
      key: "3",
      a1: "0003",
      a2: "2020-01-10",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "440,000",
    },
  ];

  const columnsPay: ColumnProps<any>[] = [
    {
      title: "合同编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "合同时间",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "合同商品",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "应收账款编号",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "付款方式",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "债权人",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "付款方",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "应收账款到期日",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "应收账款金额",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
  ];

  const dataSourceCar = [
    {
      key: "1",
      a1: "某产品一期",
      a2: "7845241800020224",
      a3: "-",
      a4: "-",
      a5: "谢**",
      a6: "229,800",
      a7: "33,200",
      a8: "3,155",
      a9: "179,600",
      a10: "12",
      a11: "0",
    },
    {
      key: "2",
      a1: "某产品二期",
      a2: "7845241800020228",
      a3: "-",
      a4: "-",
      a5: "王**",
      a6: "328,810",
      a7: "31,900",
      a8: "3,195",
      a9: "179,600",
      a10: "24",
      a11: "0",
    },
  ];

  const columnsCar: ColumnProps<any>[] = [
    {
      title: "产品名称",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "订单号",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "资产类别",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "资产到期日",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "客户姓名",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "厂商指导价",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "首付",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "月租",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "尾款",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
    {
      title: "已还期数",
      dataIndex: "a10",
      key: "a10",
      align: "center",
    },
    {
      title: "当前剩余期数",
      dataIndex: "a11",
      key: "a11",
      align: "center",
    },
  ];

  const dataSourceF = [
    {
      key: "1",
      a1: "0001",
      a2: "31001001",
      a3: "某企业A",
      a4: "A001B002C001",
      a5: "民营企业",
      a6: "王**",
      a7: "3002,000",
      a8: "2020-08-01",
      a9: "600,000",
      a10: "8%",
    },
    {
      key: "2",
      a1: "0002",
      a2: "31001002",
      a3: "某企业B",
      a4: "A001B002C002",
      a5: "个体工商户",
      a6: "石**",
      a7: "3002,000",
      a8: "2020-09-01",
      a9: "600,000",
      a10: "5%",
    },
    {
      key: "3",
      a1: "0003",
      a2: "31001003",
      a3: "某企业C",
      a4: "A001B002C003",
      a5: "私营企业",
      a6: "吕**",
      a7: "3002,000",
      a8: "2020-10-01",
      a9: "600,000",
      a10: "9%",
    },
  ];

  const columnsF: ColumnProps<any>[] = [
    {
      title: "项目编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "企业编号",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "企业名称",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "统一社会信用代码",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "企业类型",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "法人姓名",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "应付账款金额",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "应付账款到期日",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "融资金额",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
    {
      title: "期望利率",
      dataIndex: "a10",
      key: "a10",
      align: "center",
    },
  ];

  const dataSourceOrder = [
    {
      key: "1",
      a1: "0001",
      a2: "31000901",
      a3: "某经销商A",
      a4: "A01B02C01",
      a5: "王**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "12%",
    },
    {
      key: "2",
      a1: "0002",
      a2: "31000902",
      a3: "某经销商B",
      a4: "A01B02C01",
      a5: "张**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "9%",
    },
    {
      key: "3",
      a1: "0003",
      a2: "31000903",
      a3: "某经销商C",
      a4: "A01B02C01",
      a5: "李**",
      a6: "A",
      a7: "400,000",
      a8: "1200,000",
      a9: "14%",
    },
  ];

  const columnsOrder: ColumnProps<any>[] = [
    {
      title: "项目编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "经销商编号",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "经销商名称",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "社会统一信用代码",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "法人姓名",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "风控评级",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "月平均进货额",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "融资金额",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "期望利率（年化）",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
  ];

  return (
    <div className="homes">
      {/* <Card>
        <header>
          <div className="img">
            <img src={logoImg} alt="" />
          </div>
          <div className="text">
            <div className="title">你好，管理员</div>
            <div className="desc">最近登录：2020-04-05 12：31：37</div>
          </div>
        </header>
      </Card> */}

      <Card title="资产概览" style={{ marginTop: "20px" }} className="messages">
        <Row gutter={24} className="rows">
          <Col span={24} className="cols">
            <Card>
              <h2 style={{ textAlign: "center" }}>订单贷资产</h2>
              <Table
                dataSource={dataSourceOrder}
                columns={columnsOrder}
                pagination={false}
              />
            </Card>
          </Col>
          <Col span={24} className="cols">
            <Card>
              <h2 style={{ textAlign: "center" }}>应收账款</h2>
              <Table
                dataSource={dataSourcePay}
                columns={columnsPay}
                pagination={false}
              />
            </Card>
          </Col>
          <Col span={24} className="cols">
            <Card>
              <h2 style={{ textAlign: "center" }}>融资租赁资产</h2>
              <Table
                dataSource={dataSourceCar}
                columns={columnsCar}
                pagination={false}
              />
            </Card>
          </Col>
          <Col span={24} className="cols">
            <Card>
              <h2 style={{ textAlign: "center" }}>家装类资产</h2>
              <Table
                dataSource={dataSourceF}
                columns={columnsF}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Home;
